
export default {
  name: 'ProductFilterList',
  props: {
    filters: Array,
    product: Object,
  },
  computed: {
    filtersSelected() {
      return { ...this.$store.state.filters_product_selected }
    },
  },
  methods: {
    async useFilter(value) {
      await this.$nextTick()
      this.filtersSelected[value.filter_value.filter_id] = value.id
      await this.$store.dispatch(
        'setFiltersProductSelected',
        this.filtersSelected
      )
      await this.$store.dispatch('setLastFilterSelected', value.id)
      this.$scrollTo('.app', 0, {
        offset: -130,
      })
    },
    updateFilter(filterId, selectedValueId) {
      this.filtersSelected[filterId] = selectedValueId
      this.$store.dispatch('setFiltersProductSelected', this.filtersSelected)
      this.$store.dispatch('setLastFilterSelected', selectedValueId)
      this.$scrollTo('.app', 0, {
        offset: -130,
      })
    },
  },
}
